
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7898"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7898"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8l2wg", function(module, exports) {

$parcel$export(module.exports, "DATE_CHANGE_EVENT_NAME", function () { return $c5305334d381683b$export$b53c5db43f8c0a35; });
$parcel$export(module.exports, "triggerDateChange", function () { return $c5305334d381683b$export$e2957ecaeee71c74; });
const $c5305334d381683b$export$b53c5db43f8c0a35 = "date-change";
const $c5305334d381683b$export$e2957ecaeee71c74 = (el, date)=>{
    el.dispatchEvent(new CustomEvent($c5305334d381683b$export$b53c5db43f8c0a35, {
        detail: date,
        bubbles: true
    }));
};

});

parcelRegister("g65ub", function(module, exports) {

$parcel$export(module.exports, "onInit", function () { return $3294a5a20cd73dee$export$13f23e293cec2ec3; });
const $3294a5a20cd73dee$export$13f23e293cec2ec3 = (callback)=>{
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", callback);
    else callback();
};

});

parcelRegister("a8V6k", function(module, exports) {

$parcel$export(module.exports, "triggerReset", function () { return $d7718b396a5b2809$export$7b10dae5380b49a5; });
$parcel$export(module.exports, "onReset", function () { return $d7718b396a5b2809$export$79fcb145cc53473e; });

var $g65ub = parcelRequire("g65ub");
const $d7718b396a5b2809$var$callbacks = [];
const $d7718b396a5b2809$export$7b10dae5380b49a5 = ()=>{
    for (const callback of $d7718b396a5b2809$var$callbacks)callback();
};
const $d7718b396a5b2809$export$79fcb145cc53473e = (callback)=>{
    $d7718b396a5b2809$var$callbacks.push(callback);
    (0, $g65ub.onInit)(()=>{
        const button = document.getElementById("reset-button");
        button.addEventListener("click", $d7718b396a5b2809$export$7b10dae5380b49a5);
    });
};

});


var $8l2wg = parcelRequire("8l2wg");

var $g65ub = parcelRequire("g65ub");

var $a8V6k = parcelRequire("a8V6k");
const $db452a0b67aa0e2c$var$MIN_YEAR = new Date().getUTCFullYear() - 110;
const $db452a0b67aa0e2c$var$MAX_YEAR = new Date().getUTCFullYear();
const $db452a0b67aa0e2c$var$getDaysInMonth = (month, year)=>{
    switch(month){
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
            return 31;
        case 4:
        case 6:
        case 9:
        case 11:
            return 30;
        case 2:
            if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) return 29;
            return 28;
        default:
            throw new Error(`Invalid month: ${month}`);
    }
};
const $db452a0b67aa0e2c$var$fillDays = (dayPicker, monthPicker, yearPicker)=>{
    const currentVal = dayPicker.value;
    dayPicker.innerHTML = "";
    const yearPickerValue = yearPicker.value;
    const monthPickerValue = monthPicker.value;
    const option = document.createElement("option");
    option.value = "";
    option.text = "--Day--";
    dayPicker.appendChild(option);
    let days;
    if (yearPickerValue === "" || monthPickerValue === "") days = 31;
    else days = $db452a0b67aa0e2c$var$getDaysInMonth(parseInt(monthPickerValue), parseInt(yearPickerValue));
    for(let i = 1; i <= days; i++){
        const option = document.createElement("option");
        option.value = i.toString();
        option.text = i.toString();
        dayPicker.appendChild(option);
    }
    if (currentVal) dayPicker.value = currentVal;
};
const $db452a0b67aa0e2c$var$fillYears = (yearPicker)=>{
    yearPicker.innerHTML = "";
    const option = document.createElement("option");
    option.value = "";
    option.text = "--Year--";
    yearPicker.appendChild(option);
    for(let i = $db452a0b67aa0e2c$var$MAX_YEAR; i >= $db452a0b67aa0e2c$var$MIN_YEAR; i--){
        const option = document.createElement("option");
        option.value = i.toString();
        option.text = i.toString();
        yearPicker.appendChild(option);
    }
};
const $db452a0b67aa0e2c$var$setupDropdownPicker = (dropdownContainer)=>{
    const dayPicker = dropdownContainer.querySelector("[name='day']");
    const monthPicker = dropdownContainer.querySelector("[name='month']");
    const yearPicker = dropdownContainer.querySelector("[name='year']");
    const hiddenInput = dropdownContainer.querySelector("[name='dropdown-date']");
    (0, $a8V6k.onReset)(()=>{
        yearPicker.value = "";
        monthPicker.value = "";
        dayPicker.value = "";
        $db452a0b67aa0e2c$var$fillDays(dayPicker, monthPicker, yearPicker);
    });
    const setInputValue = (hiddenInput, yearPicker, monthPicker, dayPicker)=>{
        if (!yearPicker.value || !monthPicker.value || !dayPicker.value) return;
        const dateString = `${yearPicker.value}-${monthPicker.value}-${dayPicker.value}`;
        hiddenInput.value = dateString;
        (0, $8l2wg.triggerDateChange)(hiddenInput, new Date(dateString));
    };
    hiddenInput.addEventListener("change", ()=>{
        const value = hiddenInput.value;
        const date = new Date(value);
        (0, $8l2wg.triggerDateChange)(hiddenInput, date);
    });
    $db452a0b67aa0e2c$var$fillDays(dayPicker, monthPicker, yearPicker);
    $db452a0b67aa0e2c$var$fillYears(yearPicker);
    [
        dayPicker,
        monthPicker,
        yearPicker
    ].forEach((element)=>{
        element.addEventListener("change", ()=>{
            setInputValue(hiddenInput, yearPicker, monthPicker, dayPicker);
        });
    });
    [
        monthPicker,
        yearPicker
    ].forEach((element)=>{
        element.addEventListener("change", ()=>{
            $db452a0b67aa0e2c$var$fillDays(dayPicker, monthPicker, yearPicker);
        });
    });
};
(0, $g65ub.onInit)(()=>{
    const dropdownContainer = document.getElementById("dropdown");
    $db452a0b67aa0e2c$var$setupDropdownPicker(dropdownContainer);
});


//# sourceMappingURL=index.faf153be.js.map
